<template></template>
<script>
import Button from "../components/Button.vue";
export default {
  components: {
    CustomButton: Button
  },
  data: function() {
    return {
      container: null,
      start: null
    };
  },
  methods: {
    emitClick: function() {
      this.$emit("start");

      if (this.container && this.container.parentNode) {
        this.container.parentNode.removeChild(this.container);
      }

      window.scrollTo({top: 0})
    }
  },
  mounted: function() {
    this.container = document.querySelector(".quiz-intro__start");
    this.start = document.querySelector(".quiz-intro__start .custom-button");
    if (this.start) {
      this.start.addEventListener("click", this.emitClick);
    }
  },
  destroyed: function() {
    if (this.start) {
      this.start.removeEventListener("click", this.emitClick);
    }
  }
};
</script>